import React from 'react';
import { GiTechnoHeart } from 'react-icons/gi';
import LogoStyles from '../styles/LogoStyles';

function Logo() {
  return (
    <LogoStyles to="/">
      <GiTechnoHeart />
    </LogoStyles>
  );
}

export default Logo;
